import { SCREENS, REDUX_ACTIONS, GAME_ID } from 'a/robovoice_prototype/data/constants';
import { persistStateTypes } from 'a/reducers/persistStateReducer';

const initState = {
  screen: SCREENS.PROGRESS,
};

const view = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        screen: payload,
      };

    // Return to Progress Screen when gamestate call has been resolved
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return {
        screen: SCREENS.PROGRESS,
      };

    // Show Loading screen when gamestate request goes out
    case persistStateTypes.REQUEST_GAMESTATE:
      return {
        screen: SCREENS.LOADING,
      };

    default:
      return state;
  }
};

export default view;
